import { buildWhatsAppUrl } from '../contact/whatsappLink.js';
import { mlvApplyZ } from './mlvZLayers.js';
import { mlvSaveFocus } from './mlvFocusRestore.js';
import { mlvModalHistoryAttach } from '../navigation/mlvModalHistoryBridge.js';
import { mlvTrack } from '../telemetry/mlvTrack.js';
import { openNegocioVecinoExplainer } from './negocioVecinoExplainer.js';

const MODAL_ID = 'mlv-pub-exito-banners-modal';
const WA_TEL = '1162399695';
const WA_MSJ =
  'Hola. Quiero información sobre precios y disponibilidad de banners';

/**
 * Tras publicar: destacados / banners y CTA a WhatsApp.
 * @param {{ onWaClick?: () => void }} [opts]
 * @returns {Promise<'wa' | 'dismiss'>}
 */
export function openModalPublicacionExitoBanners(opts = {}) {
  const { onWaClick } = opts;
  document.getElementById(MODAL_ID)?.remove();

  const waUrl =
    buildWhatsAppUrl(WA_TEL, WA_MSJ) || `https://wa.me/5491162399695?text=${encodeURIComponent(WA_MSJ)}`;

  return new Promise((resolve) => {
    mlvTrack('pub_exito_modal_open', {});
    const restoreFocus = mlvSaveFocus();
    let resolved = false;
    let pendingHow = /** @type {'wa' | 'dismiss'} */ ('dismiss');

    const backdrop = document.createElement('div');
    backdrop.id = MODAL_ID;
    backdrop.className =
      'fixed inset-0 flex items-end justify-center bg-black/45 p-4 backdrop-blur-[2px] sm:items-center';
    mlvApplyZ(backdrop, 'pubExitoBanners');
    backdrop.setAttribute('role', 'dialog');
    backdrop.setAttribute('aria-modal', 'true');
    backdrop.setAttribute('aria-labelledby', 'mlv-pub-exito-banners-title');

    backdrop.innerHTML = `
 <div class="mlv-pub-exito-panel w-full max-w-md rounded-t-3xl border border-amber-200/80 bg-gradient-to-b from-amber-50/95 to-white p-5 shadow-2xl ring-1 ring-amber-400/20 sm:rounded-3xl">
      <div class="mb-1 flex items-center gap-2">
        <span class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-amber-500 text-lg text-white shadow-sm" aria-hidden="true">&#10003;</span>
        <h2 id="mlv-pub-exito-banners-title" class="font-heading text-base font-bold leading-tight text-slate-900" tabindex="-1">
          ¡Publicado!
        </h2>
      </div>
      <p class="mt-3 text-sm leading-relaxed text-slate-700">
        Tu aviso ya está en el catálogo del barrio. Si querés <span class="font-semibold text-slate-800">más visibilidad</span>, podemos contarte opciones por WhatsApp (sin obligación).
      </p>
      <button type="button" id="mlv-pub-exito-como-destacar" class="mt-3 w-full rounded-xl border border-amber-200/90 bg-white py-2.5 text-xs font-semibold text-amber-900 hover:bg-amber-50">
        ¿Qué es destacar o publicidad?
      </button>
      <a
        id="mlv-pub-exito-banners-wa"
        href="#"
        target="_blank"
        rel="noopener noreferrer"
        class="mt-5 flex w-full items-center justify-center gap-2 rounded-xl bg-brand-primary py-3.5 text-sm font-bold text-white shadow-md transition hover:brightness-95 focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2"
      >
        Quiero destacar / publicidad
      </a>
      <p class="mt-3 text-center text-[11px] text-slate-500">Tocá fuera de esta ventana para seguir.</p>
    </div>
  `;

    const waBtn = backdrop.querySelector('#mlv-pub-exito-banners-wa');
    if (waBtn) waBtn.href = waUrl;

    backdrop.querySelector('#mlv-pub-exito-como-destacar')?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      void openNegocioVecinoExplainer({ section: 'publicidad' });
    });

    const hist = mlvModalHistoryAttach(() => {
      document.removeEventListener('keydown', onKey);
      try {
        restoreFocus();
      } catch (_e) {
        /* ignore */
      }
      backdrop.remove();
      if (!resolved) {
        resolved = true;
        resolve(pendingHow);
      }
    });
    function finish(how) {
      if (resolved) return;
      pendingHow = how;
      hist.closeFromUi();
    }
    function onKey(e) {
      if (e.key === 'Escape') finish('dismiss');
    }

    document.body.appendChild(backdrop);
    document.addEventListener('keydown', onKey);

    const panel = backdrop.querySelector('.mlv-pub-exito-panel');
    const titleEl = backdrop.querySelector('#mlv-pub-exito-banners-title');
    requestAnimationFrame(() => {
      (titleEl || waBtn)?.focus?.({ preventScroll: true });
    });

    backdrop.addEventListener('click', (e) => {
      if (e.target === backdrop) finish('dismiss');
    });

    const btnComo = backdrop.querySelector('#mlv-pub-exito-como-destacar');
    if (panel) {
      panel.addEventListener('click', (e) => {
        if (waBtn && (e.target === waBtn || waBtn.contains(e.target))) return;
        if (btnComo && (e.target === btnComo || btnComo.contains(e.target))) return;
        finish('dismiss');
      });
    }

    if (waBtn) {
      waBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        try {
          onWaClick?.();
        } catch (_e) {
          /* ignore */
        }
        mlvTrack('pub_exito_wa_click', {});
        queueMicrotask(() => finish('wa'));
      });
    }
  });
}
